import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/core/services/storage.service';
import { SafeUrlPipe } from 'src/app/core/pipes/safe-url.pipe';

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.css']
})
export class ReportingComponent implements OnInit {

  reportIssue!: string;
  contactguid: any;
  userDetails: any;
  constructor(private storageService: StorageService) { }

  ngOnInit(): void {
    this.userDetails = this.storageService.getSessionStorageData('userDetails');
    this.reportIssue = "http://ae-dxbfindyn001/ReportsPBI/powerbi/Risk_Assessment_Report-Dev?filter=contacts/contactid eq '"
      + this.userDetails?.contactguid + "'&rs:embed=true";
    //console.log(this.reportIssue);
  }

}
